import { useContext } from 'react';
import { useIntl, defineMessages, FormattedMessage } from '@alltrails/shared/react-intl';
import Button from '@alltrails/shared/denali/components/Button';

import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import LearnMore from '../LearnMore';
import { PrintContext } from '../../printContext';
import { Grids, GRID_LABELS } from '../../constants';

type Props = {
  isMobileWidth?: boolean;
};

const GRID_STRINGS = defineMessages({
  GRID: { defaultMessage: 'Grid' },
  CONTENT: {
    defaultMessage:
      "Decimal degrees (DD) expresses latitude and longitude as decimal fractions of a degree.{br}Example: 37.7907, -122.4060{br}{br}DMS expresses latitude and longitude in degrees, minutes, and seconds.{br}Example: 37°47'26.5\"N 122°24'21.6\"W{br}{br}UTM divides the Earth's surface into sections and expresses locations as coordinates within those sections.{br}Example: 10S 552299 4182759"
  }
});

const Grid = ({ isMobileWidth = false }: Props) => {
  const {
    formattedDefaultMessages: { GRID }
  } = useFormatMessage(GRID_STRINGS);
  const { grid, setGrid } = useContext(PrintContext);
  const intl = useIntl();

  return (
    <div className="buttonRow">
      {Object.values(Grids).map(g => {
        const label = intl.formatMessage(GRID_LABELS[g]);

        return (
          <Button
            text={label}
            className="settingsButton"
            key={`grid-${g}`}
            onClick={() => setGrid(g)}
            testId={label}
            variant={grid === g ? 'primary' : 'default'}
          />
        );
      })}

      <LearnMore title={GRID} content={<FormattedMessage {...GRID_STRINGS.CONTENT} values={{ br: <br /> }} />} grid isMobileWidth={isMobileWidth} />
    </div>
  );
};

export default Grid;
